<template>
    <div>
        <section class="main-bg-gradient skew top-panel services-top">
            <div class="inside-skew">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <div id="service-window">
                                <img v-show="windowBox === 1" src="/static/images/services/window1.svg"/>
                                <img v-show="windowBox === 2" src="/static/images/services/window2.svg"/>
                                <img v-show="windowBox === 3" src="/static/images/services/window3.svg"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="skew">
            <div class="inside-skew">
                <div class="container">
                    <div class="row window-boxes animated fadeIn">
                        <div class="col-lg-4">
                            <div class="window-box" @click="windowBox = 1" :class="{'active': windowBox === 1}">
                                <b>{{ $t('service.mainbox1Header') }}</b>
                                <p class="smaller">
                                    {{ $t('service.mainbox1Text') }}
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="window-box" @click="windowBox = 2" :class="{'active': windowBox === 2}">
                                <b>{{ $t('service.mainbox2Header') }}</b>
                                <p class="smaller">
                                    {{ $t('service.mainbox2Text') }}
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="window-box" @click="windowBox = 3" :class="{'active': windowBox === 3}">
                                <b>{{ $t('service.mainbox3Header') }}</b>
                                <p class="smaller">
                                    {{ $t('service.mainbox3Text') }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4" align="right">
                            <img src="https://assets.railsware.com/images/services/web-services-5a281186.svg"/>
                        </div>
                        <div class="col-lg-6">
                            <h2>
                                {{ $t('service.firstServiceHeader') }}
                            </h2>
                            <p>
                                {{ $t('service.firstServiceText') }}
                            </p>
                            <a href="#" class="btn btn-rounded btn-primary">
                                {{ $t('service.readmore') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-deveo-light skew bottom-panel">
            <div class="inside-skew">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4" align="right">
                            <img src="https://assets.railsware.com/images/services/web-services-5a281186.svg"/>
                        </div>
                        <div class="col-lg-6">
                            <h2>
                                {{ $t('service.secondServiceHeader') }}
                            </h2>
                            <p>
                                {{ $t('service.secondServiceText') }}
                            </p>
                            <a href="#" class="btn btn-rounded btn-primary">
                                {{ $t('service.readmore') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-deveo-white">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h3>
                            ???
                        </h3>
                        <div style="height:200px;"></div>
                    </div>
                </div>
            </div>
        </section>
        <!--<section class="bg-deveo-white skew">
            <div id="stripes">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>-->
    </div>
</template>
<style lang="scss" scoped>
    $main-color: #607D8B;
    .main-color {
        color: $main-color;
    }
    .main-bg {
        background: $main-color;
    }
    .main-bg-gradient{
        background: linear-gradient(150deg, rgba(darken($main-color, 10%), 0.85) 15%, rgba(darken($main-color, 10%), 0.85) 70%), url('/static/images/bg.svg') bottom;
        background-size: cover;
    }
    p{
        font-weight: 300;
        margin: 20px 0;
    }
    @keyframes tester{
        0%{
            transform: scale(0.5);
            opacity: 0;
        }
        100%{
            transform: scale(1);
            opacity: 1;
        }
    }
    #service-window{
        width: 100%;
        margin-bottom: -300px;
    }
    #service-window img{
        width: 100%;
        border-radius: 4px;
        box-shadow: 0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07);
        animation: tester 0.5s ease-in-out;
    }
    .services-top{
        margin-bottom: 100px;
    }
    .window-boxes{
        margin-bottom: 200px;
    }
    .window-box{
        background: #fff;
        padding: 15px;
        box-shadow: 0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07);
        border-radius: 4px;
        border: 1px solid transparent;
        transition: 0.3s ease all;
    }
    .window-box:hover{
        transform: scale(1.025);
        cursor: pointer;
    }
    .window-box.active{
        border: 2px solid $main-color;
    }
    b{
        font-weight: 500;
    }
    p.smaller{
        margin: 0;
        font-size: 0.9rem;
    }
    #stripes {
        display: grid;
        grid: repeat(5, 200px) / repeat(10, 1fr);
        background: rgba(0,0,0,.1)
    }

    #stripes :nth-child(1) {
        grid-column: span 3;
        background: linear-gradient(to right, darken($main-color,10%), lighten($main-color, 10%))
    }

    #stripes :nth-child(2) {
        grid-area: 3 / span 3 / auto / -1;
        background: blue;
    }

    #stripes :nth-child(3) {
        grid-row: 4;
        grid-column: span 5;
        background: green;
    }

    #stripes :nth-child(4){
        grid-row: 2;
        grid-area: 2 / 3 / 2 / 6;
        background: linear-gradient(to right, darken(red,10%), lighten(red, 10%))
    }
</style>
<script>
    export default{
        data () {
            return {
                windowBox: 1
            }
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?59b63dd8